import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getDesignPanelPreviewStateMap,
  getPartToPreviewStateMap,
} from '@wix/editor-elements-preview-utils';

import type {
  CollapsibleTextDefinition,
  ICollapsibleTextMapperProps,
} from '../CollapsibleText.types';
import { props as viewerPropsMapper } from './CollapsibleText.mapper';

const props = composeMapper<
  ICollapsibleTextMapperProps,
  CollapsibleTextDefinition
>()(
  viewerPropsMapper,
  {
    remove: [
      'compId',
      'fullNameCompType',
      'language',
      'mainPageId',
      'trackClicksAnalytics',
    ],
    add: ['compPreviewState'],
  },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { compPreviewState } = deps;

    const designPanelPreviewStateMap =
      getDesignPanelPreviewStateMap(compPreviewState);

    return {
      ...viewerProps,
      trackClicksAnalytics: false,
      partToPreviewStateMap: getPartToPreviewStateMap(
        designPanelPreviewStateMap,
      ),
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
